export enum ISGapsRecommendationEnum {
  IMPROVE_SEO = 'IMPROVE_SEO',
  IMPROVE_PPC = 'IMPROVE_PPC',
  NONE = 'NO_RECOMMENDATION',
  OPTIMISED_SEO = 'OPTIMISED_SEO',
  OPTIMISED_PPC = 'OPTIMISED_PPC',
}
